/* tslint:disable */
/* eslint-disable */
/* @relayHash 47469f847cda194e2cce69c89ee615b6 */

import { ConcreteRequest } from "relay-runtime";
export type SetNonTradeUserToSuspectedTradeInput = {
    userId: string;
    clientMutationId?: string | null;
};
export type setNonTradeUserToSuspectedTradeMutationVariables = {
    input: SetNonTradeUserToSuspectedTradeInput;
};
export type setNonTradeUserToSuspectedTradeMutationResponse = {
    readonly setNonTradeUserToSuspectedTradeMutation: {
        readonly verifiedTradeStatus: string | null;
    } | null;
};
export type setNonTradeUserToSuspectedTradeMutation = {
    readonly response: setNonTradeUserToSuspectedTradeMutationResponse;
    readonly variables: setNonTradeUserToSuspectedTradeMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetNonTradeUserToSuspectedTradeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetNonTradeUserToSuspectedTradePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "verifiedTradeStatus",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "setNonTradeUserToSuspectedTradeMutation",
    "id": "ferrum/255.0.0-2020-03-10T14:28:54.909Z/setNonTradeUserToSuspectedTradeMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0a90bfe522581c99eb190f2a4f33421c';
export default node;
